/** Maximum length of a track name. */
export const MAX_NAME_LENGTH = 80;

/** Derives a kebab-case id from a free-text name, matching config-authored tracks. */
export const slugifyTrackId = (value: string): string =>
  value
    // Bound the input so slug generation stays linear regardless of the caller.
    .slice(0, MAX_NAME_LENGTH)
    .toLowerCase()
    .replaceAll(/[^a-z0-9]+/g, '-')
    .replaceAll(/-+/g, '-')
    .replace(/^[^a-z]+/, '')
    // Runs are already collapsed above, so only a single trailing hyphen can
    // remain; matching without `+` avoids super-linear backtracking.
    .replace(/-$/, '');
